export default {
  /*景区星级*/
  scenicStarArr:[
    {id:'1',name:'A'},
    {id:'2',name:'AA'},
    {id:'3',name:'AAA'},
    {id:'4',name:'AAAA'},
    {id:'5',name:'AAAAA'},
    {id:'0',name:'其他'},
    { id: '', name: '不限' },
  ],
  /*景点主题*/
  scenicThemeArr:[
    {id:'1',name:'湖光山色'},
    {id:'2',name:'主题乐园'},
    {id:'3',name:'海滨岛屿'},
    {id:'4',name:'古迹遗址'},
    {id:'5',name:'赛事演出'},
    {id:'6',name:'民俗风情'},
    {id:'7',name:'田园度假'},
    {id:'8',name:'园林景观'},
    {id:'9',name:'登山徒步'},
    {id:'10',name:'漂流戏水'},
    {id:'11',name:'温泉度假'},
    {id:'12',name:'水乡古镇'},
    {id:'13',name:'动植物园'},
    {id:'14',name:'宗教祈福'},
    {id:'15',name:'时令采摘'},
    {id:'16',name:'团队拓展'},
    {id:'17',name:'博物馆'},
    {id:'18',name:'游船'},
    {id:'19',name:'滑雪'},
    {id:'20',name:'骑行'},
    {id:'21',name:'旅游商贸城'},
    {id:'22',name:'红色旅游基地'},
    {id:'23',name:'研学基地'},
    {id:'24',name:'喀斯特地貌'},
    {id:'25',name:'喀斯特溶洞'},
  ],
  /*景点票种*/
  ticketTypeArr: [
    /*散客票种类*/
    {id: 1, name: '特惠票'},
    {id: 2,name: '成人票'},
    {id: 3,name: '学生票'},
    {id: 4,name: '亲子家庭票'},
    {id: 5,name: '组合套票'},
    {id: 6,name: '老年票'},
    /*设置团队订单金额时4种人群*/
    // {id: 6,name: '成人'},
    // {id: 7,name: '儿童'},
    // {id: 8,name: '老人'},
    // {id: 9,name: '特惠人群'},
  ],
  /*景点团队门票类型*/
  groupTicketType: [
    {id: 1, name: '成人团'},
    {id: 2, name: '老年团'},
    {id: 3, name: '学生团'},
    {id: 4, name: '散拼团'},
    {id: 5, name: '亲子团'},
    {id: 6, name: '考察团'},
    {id: 7, name: '外宾团'},
  ],
}
